import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import {DialogTitle, TextField} from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {}
}));

const AddRole = props => {
  const { className, ...rest } = props;
  const [open, setOpen] = React.useState(true);
  const theme = useTheme();
  const [rolename, setRolename] = React.useState('');
  const [roleobj, setRoleobj] = React.useState(props.roleObj ? props.roleObj : {});

  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState('sm');
  const classes = useStyles();
  const handleSave = () => {
    props.onUpdate(rolename,roleobj)
  };
  const handleinputchange = type => e => {
    setRolename(e.target.value)
    setRoleobj({...roleobj,name :e.target.value})
  };
  const handleClose = () => {
    setOpen(false);
    props.onDismiss()
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{roleobj.id == null ? "Add New Language" : "Edit Language"}</DialogTitle>
        <DialogContent>
          
        <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            value={roleobj ? roleobj.name : null}
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                            onChange={handleinputchange('name')}
                           label="Language"
                          />

        </DialogContent>
        <DialogActions>
          <Button  onClick={handleClose} color="default">
            Cancel
          </Button>
          <Button onClick={handleSave} variant="contained" color="primary" autoFocus>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

AddRole.propTypes = {
  className: PropTypes.string
};

export default AddRole;
